import { useEffect, useState } from "react";
import { useLocation } from "wouter";
import { motion } from "framer-motion";
import { CheckCircle2, Sparkles } from "lucide-react";
import { useAppStore } from "@/store";

export default function SubscriptionSuccess() {
  const [, setLocation] = useLocation();
  const { fetchSubscription } = useAppStore();
  const [countdown, setCountdown] = useState(3);

  useEffect(() => {
    fetchSubscription();
  }, [fetchSubscription]);

  useEffect(() => {
    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          setLocation("/");
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [setLocation]);

  return (
    <div className="min-h-screen flex items-center justify-center p-4"
      style={{ background: "hsl(222 44% 6%)" }}
    >
      <motion.div
        initial={{ opacity: 0, scale: 0.9, y: 20 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        transition={{ type: "spring", stiffness: 300, damping: 30 }}
        className="text-center max-w-md"
      >
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ delay: 0.2, type: "spring", stiffness: 400, damping: 20 }}
          className="w-20 h-20 rounded-full mx-auto mb-6 flex items-center justify-center"
          style={{
            background: "linear-gradient(135deg, hsl(188 90% 42%) 0%, hsl(205 88% 52%) 100%)",
          }}
        >
          <CheckCircle2 className="w-10 h-10 text-white" />
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4 }}
        >
          <div className="flex items-center justify-center gap-2 mb-3">
            <Sparkles className="w-5 h-5 text-primary" />
            <span className="text-primary font-semibold text-sm">ScribPost Pro</span>
          </div>

          <h1 className="text-3xl font-display font-bold text-foreground mb-3">
            You're all set!
          </h1>
          <p className="text-muted-foreground text-lg mb-8">
            Welcome to ScribPost Pro. Unlimited posts in your voice, forever.
          </p>

          <p className="text-sm text-muted-foreground">
            Redirecting to dashboard in {countdown}...
          </p>
        </motion.div>
      </motion.div>
    </div>
  );
}
